// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserCaptureSourceRoleView { 
    /**
     * The capture source primary key
     */
    id: number;
    /**
     * The capture source code
     */
    code: UserCaptureSourceRoleView.CodeEnum;
    /**
     * The user id
     */
    idUser: number;
    /**
     * The site ids
     */
    idSites: Array<string>;
    /**
     * The team id
     */
    idTeam: number;
    /**
     * The role for the user
     */
    role: UserCaptureSourceRoleView.RoleEnum;
}
export namespace UserCaptureSourceRoleView {
    export type CodeEnum = 'air' | 'water_intake' | 'water_discharge' | 'residue' | 'energy';
    export const CodeEnum = {
        air: 'air' as CodeEnum,
        water_intake: 'water_intake' as CodeEnum,
        water_discharge: 'water_discharge' as CodeEnum,
        residue: 'residue' as CodeEnum,
        energy: 'energy' as CodeEnum
    };
    export type RoleEnum = 'admin' | 'approver' | 'preparer' | 'reviewer';
    export const RoleEnum = {
        admin: 'admin' as RoleEnum,
        approver: 'approver' as RoleEnum,
        preparer: 'preparer' as RoleEnum,
        reviewer: 'reviewer' as RoleEnum
    };
}


